import React from "react";
import { Convocatoria } from "../../../models/ConvocatoriasModel/convocatoria.model";
import { PostulacionBannerShared } from "../../../components/Generales/PostulacionBannerShared";

interface IProps {
  BannerText: string;
  convocatorias: Convocatoria;
}

export const BannerJurados: React.FC<IProps> = (props: IProps) => {
  return (
    <PostulacionBannerShared
      convocatorias={props.convocatorias}
      role="jurados"
      showExpression={false}
      supportSMImage={false}
    />
  );
};
